import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentsService {

  constructor(private apiService: ApiBaseService) { }

  async getProjectSharepointDirectory(payLoad: any, showLoader: boolean = true): Promise<any> {
    return this.apiService.httpRequest('DocumentsService/GetProjectSharepointDirectory', payLoad, true, showLoader);
  }

  async getFileFromSharepoint(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('DocumentsService/GetFileFromSharepoint', payLoad, true, true);
  }

  async getFileFromBlob(payload: any): Promise<any> {
    return this.apiService.httpRequest('DocumentsService/GetFileFromBlob', payload, true, true);
  }

  async getGridConnectionSharepointDirectory(payload: any): Promise<any> {
    return this.apiService.httpRequest('DocumentsService/GetGridConnectionSharepointDirectory', payload, true, true);
  }

  async getMultipleFilesForDownload(payload: any): Promise<any> {
    return this.apiService.httpRequest('DashboardService/GetMultipleFilesForDownload', payload, true, true);
  }

  async getExportPackagePreflight(payload: any): Promise<any> {
    return this.apiService.httpRequest('DocumentsService/GetExportPackagePreflight', payload, true, true);
  }

  async getExportPackageData(payload: any): Promise<{ blob: Blob; fileName: string }> {
    return this.apiService.httpPostBlobFileRequest('DocumentsService/GetExportPackageData', payload, true);
  }
  
  async getProjectTaskFile(payload: any): Promise<any> {
    return this.apiService.httpRequest('ProjectTasksService/GetProjectTaskFile', payload, true, true);
  }

  async getUserDocumentAccessToken(payload: any): Promise<any> {
    return this.apiService.httpRequest('DocumentsService/GetUserDocumentAccessToken', payload, true, true);
  }

  async getPropertyFileFromSharepoint(payload: any): Promise<any> {
    return this.apiService.httpRequest('PropertyService/GetPropertyFileFromSharepoint', payload, true, true);
  }

  async openCommentAttachment(payload: any): Promise<any> {
    return this.apiService.httpRequest('CommentService/OpenCommentAttachment', payload, true, true)
  }



}
